import React from "react";
import { withStyles } from '@material-ui/styles';
import withShowToast from '../../hocs/with_show_toast.js';
import { compose } from 'redux';

import {
  Dialog, DialogActions, 
  DialogContent, 
  DialogTitle
} from '@material-ui/core';

import I18n from "../../base/i18n.js";

import Button from "../../base/buttons/button.js";
import FormFields from "../../base/form/form_fields.js";
import { MemberModel } from "../../models/companies/member_model.js";

import CreateMemberUseCase from "../../use_cases/admin/companies/members/create_member_use_case.js";

const styles = theme => ({
  root: {
    "& .MuiDialog-paper": {
      width: "100%",
      maxWidth: "500px"
    }
  }
});

class InviteMember extends React.Component {

  constructor(props) {
    super(props);
    this.state = {};

    const { company } = props;

    this.member = {
      companyId: company.id,
      user: {}
    }

  }

  static getDerivedStateFromProps(props, state) {
    return {
      ...state,
      open: props.open
    }
  }

  onItemChange = (changedItem) => {
    this.member = changedItem
    this.member.passwordConfirmation = this.member.password;
  }

  onSubmit = (event) => {
    event.preventDefault();
    this.setState({
      submit: true,
      errorData: undefined
    })

    CreateMemberUseCase.execute(this.member)
    .then((result) => {
      const { data : { member } } = result;
      const { onSave, close, showSuccessMessage } = this.props;
      if(onSave) {
        onSave(member);
      }
      showSuccessMessage(I18n.t("admin.modal.invite_member.invited", {name: member.user.email}));
      close();
    })
    .catch((result) => {
      const { errorData } = result;
      const { showServerErrorIfNeed } = this.props;
      this.setState({
        submit: false,
        errorData: errorData
      });
      showServerErrorIfNeed(result);
    })
  }

  onClose = (event) => {
    const { onClose } = this.props;
    const { submit } = this.state;
    if(!submit) {
      onClose()
    }
  }
  
  render() {
    const { classes } = this.props;

    const { open, errorData, submit } = this.state;

    return <Dialog open = { open } 
                   onClose = { this.onClose }
                   scroll = { "paper" }
                   className = { classes.root } >
    <DialogTitle>
      { I18n.t("admin.modal.invite_member.title") }
    </DialogTitle>
    <form onSubmit = { this.onSubmit } >
      <DialogContent dividers = { true } >
        <FormFields formFields = { MemberModel.formFields() } 
                    item = { this.member }
                    errorData = { errorData }
                    onItemChange = { this.onItemChange } />
      </DialogContent>
      <DialogActions>
        <Button type = { "submit" } 
                disabled = { submit }>
          { I18n.t("action.invite") }
        </Button>
      </DialogActions>
    </form>
  </Dialog>
  }
}

export default compose(
  withShowToast,
  withStyles(styles)
)(InviteMember);
